import { render, staticRenderFns } from "./getYzmCode.vue?vue&type=template&id=9d6e9272&scoped=true"
import script from "./getYzmCode.vue?vue&type=script&lang=js"
export * from "./getYzmCode.vue?vue&type=script&lang=js"
import style0 from "./getYzmCode.vue?vue&type=style&index=0&id=9d6e9272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6e9272",
  null
  
)

export default component.exports